let activeTenantId = ''

/** Selects the server-resolved immutable tenant identity for this document. */
export function activateCompanyStorage(tenantId: string): void {
  activeTenantId = tenantId
}

/** Namespaces browser state without relying on the editable URL name. */
export function companyStorageKey(key: string): string {
  if (!activeTenantId) throw new Error('Choose a company before saving session state.')
  return `salesRepApp_v2:${encodeURIComponent(activeTenantId)}:${key}`
}

/** Session storage limited to the company active in this browser document. */
export const companySessionStorage = {
  getItem(key: string): string | null { return activeTenantId ? sessionStorage.getItem(companyStorageKey(key)) : null },
  setItem(key: string, value: string): void { sessionStorage.setItem(companyStorageKey(key), value) },
  removeItem(key: string): void { if (activeTenantId) sessionStorage.removeItem(companyStorageKey(key)) }
}

/** Removes the current company's session and saved data without touching other companies. */
export function clearCompanySessionStorage(): void {
  if (!activeTenantId) return
  const prefix = companyStorageKey('')
  for (const key of Object.keys(sessionStorage)) if (key.startsWith(prefix)) sessionStorage.removeItem(key)
}
